import * as types from 'store/sidebar/sidebarTypes'

export function launchSurveys(payload){
    return{
        type: types.LAUNCH_SURVEYS_REQUESTED,
        payload: payload
    }
}

export function closeSurveys(payload){
    return{
        type: types.CLOSE_SURVEYS_REQUESTED,
        payload: payload
    }
}